import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { PriceFilterInput, SyncPriceInput, UpdatePricePlanAttachmentDataInput } from './inputs';
import { PriceRef } from './refs';
import { PriceResource, PriceListItemResource } from './resources';

export default class Price {
    private basePath = '/api/price';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Sync price data
    sync = async (input: SyncPriceInput): Promise<PriceRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`, input);

        return data;
    };

    // Get list of prices
    get = async (filter?: PriceFilterInput): Promise<CollectionResource<PriceListItemResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single price
    getById = async (id: ID): Promise<PriceResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Get single price by external ID
    getByExternalId = async (priceExternalId: string): Promise<PriceResource> => {
        const { data } = await this.http.get(`${this.basePath}/external/${priceExternalId}`);

        return data;
    };

    // Update price plan attachment data
    updatePlanAttachmentData = async (id: ID, input: UpdatePricePlanAttachmentDataInput): Promise<PriceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/plan`, input);

        return data;
    };

    // Remove assigned plan from price
    removeAssignedPlan = async (id: ID): Promise<PriceRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/plan`);

        return data;
    };
}
